/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel';
import {
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList {
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    ageType?: Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeType>;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    nameLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    seiInput?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    meiInput?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    relationshipLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    relationshipPd?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    ageLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    ageInput?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    pricetypeLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    pricetypePd?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    agetypeLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    agetypePd?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    subsidyNameLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    applicableDateFromLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    applicableDateToLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    receptionDateFromLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    receptionDateToLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    priceList?: Array<JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList>;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    remainingCountLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    remainingAmountLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    applicableDegreeCntLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    personAccompanyNecessityLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    tgtAgeLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    costUnderChargeableNecessityLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList
     */
    multipleUnusableNecessityLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ageType': !exists(json, 'ageType') ? undefined : ((json['ageType'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeFromJSON)),
        'nameLabel': !exists(json, 'nameLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelFromJSON(json['nameLabel']),
        'seiInput': !exists(json, 'seiInput') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputFromJSON(json['seiInput']),
        'meiInput': !exists(json, 'meiInput') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputFromJSON(json['meiInput']),
        'relationshipLabel': !exists(json, 'relationshipLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelFromJSON(json['relationshipLabel']),
        'relationshipPd': !exists(json, 'relationshipPd') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSON(json['relationshipPd']),
        'ageLabel': !exists(json, 'ageLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSON(json['ageLabel']),
        'ageInput': !exists(json, 'ageInput') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputFromJSON(json['ageInput']),
        'pricetypeLabel': !exists(json, 'pricetypeLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabelFromJSON(json['pricetypeLabel']),
        'pricetypePd': !exists(json, 'pricetypePd') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSON(json['pricetypePd']),
        'agetypeLabel': !exists(json, 'agetypeLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSON(json['agetypeLabel']),
        'agetypePd': !exists(json, 'agetypePd') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdFromJSON(json['agetypePd']),
        'subsidyNameLabel': !exists(json, 'subsidyNameLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelFromJSON(json['subsidyNameLabel']),
        'applicableDateFromLabel': !exists(json, 'applicableDateFromLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSON(json['applicableDateFromLabel']),
        'applicableDateToLabel': !exists(json, 'applicableDateToLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelFromJSON(json['applicableDateToLabel']),
        'receptionDateFromLabel': !exists(json, 'receptionDateFromLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSON(json['receptionDateFromLabel']),
        'receptionDateToLabel': !exists(json, 'receptionDateToLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelFromJSON(json['receptionDateToLabel']),
        'priceList': !exists(json, 'priceList') ? undefined : ((json['priceList'] as Array<any>).map(JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListFromJSON)),
        'remainingCountLabel': !exists(json, 'remainingCountLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabelFromJSON(json['remainingCountLabel']),
        'remainingAmountLabel': !exists(json, 'remainingAmountLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabelFromJSON(json['remainingAmountLabel']),
        'applicableDegreeCntLabel': !exists(json, 'applicableDegreeCntLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelFromJSON(json['applicableDegreeCntLabel']),
        'personAccompanyNecessityLabel': !exists(json, 'personAccompanyNecessityLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabelFromJSON(json['personAccompanyNecessityLabel']),
        'tgtAgeLabel': !exists(json, 'tgtAgeLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelFromJSON(json['tgtAgeLabel']),
        'costUnderChargeableNecessityLabel': !exists(json, 'costUnderChargeableNecessityLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelFromJSON(json['costUnderChargeableNecessityLabel']),
        'multipleUnusableNecessityLabel': !exists(json, 'multipleUnusableNecessityLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelFromJSON(json['multipleUnusableNecessityLabel']),
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ageType': value.ageType === undefined ? undefined : ((value.ageType as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseScrennDisplayItemListAgeTypeToJSON)),
        'nameLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelToJSON(value.nameLabel),
        'seiInput': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputToJSON(value.seiInput),
        'meiInput': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputToJSON(value.meiInput),
        'relationshipLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelToJSON(value.relationshipLabel),
        'relationshipPd': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdToJSON(value.relationshipPd),
        'ageLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelToJSON(value.ageLabel),
        'ageInput': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputToJSON(value.ageInput),
        'pricetypeLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypeLabelToJSON(value.pricetypeLabel),
        'pricetypePd': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdToJSON(value.pricetypePd),
        'agetypeLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelToJSON(value.agetypeLabel),
        'agetypePd': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdToJSON(value.agetypePd),
        'subsidyNameLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelToJSON(value.subsidyNameLabel),
        'applicableDateFromLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelToJSON(value.applicableDateFromLabel),
        'applicableDateToLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelToJSON(value.applicableDateToLabel),
        'receptionDateFromLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelToJSON(value.receptionDateFromLabel),
        'receptionDateToLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelToJSON(value.receptionDateToLabel),
        'priceList': value.priceList === undefined ? undefined : ((value.priceList as Array<any>).map(JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListToJSON)),
        'remainingCountLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingCountLabelToJSON(value.remainingCountLabel),
        'remainingAmountLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRemainingAmountLabelToJSON(value.remainingAmountLabel),
        'applicableDegreeCntLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelToJSON(value.applicableDegreeCntLabel),
        'personAccompanyNecessityLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPersonAccompanyNecessityLabelToJSON(value.personAccompanyNecessityLabel),
        'tgtAgeLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelToJSON(value.tgtAgeLabel),
        'costUnderChargeableNecessityLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelToJSON(value.costUnderChargeableNecessityLabel),
        'multipleUnusableNecessityLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelToJSON(value.multipleUnusableNecessityLabel),
    };
}

